export default {
  banner: {
    joinReferral: 'Join the Cookie Wow Referral Program',
    justShare: 'Easily earn money just by sharing!',
    joinNow: 'Join now!',
  },
}
